import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "app/@Base/components/NavBar/store/actions";
import Offcanvas from "react-bootstrap/Offcanvas";
import OptionAppMenu from "./OptionAppMenu";
import LeftSecondaryMenu from "./LeftSecondaryMenu";
import OptionNav from "../OptionNav/OptionNav";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./AppMenu.css";
import FindBar from "../FindBar/FindBar";

function LeftMenu({ name, type, section, menuOptions, ...props }) {
  const dispatch = useDispatch();
  const is4K = useMediaQuery("(min-width: 3840px)");
  const [options, setOptions] = useState([]);
  const [show, setShow] = useState(false);

  const ROOT = process.env.REACT_APP_CMS_STATIC;

  const { contentNavbar } = useSelector(
    ({ mainNavBar }) => mainNavBar.mainNavbar
  );

  useEffect(() => {
    !contentNavbar && dispatch(CMSActions.getMainNavBar());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contentNavbar) {
      setOptions(contentNavbar.opciondemenu);
    }
  }, [contentNavbar]);

  const items = options.map((option, index) => (
    <OptionNav
      key={index}
      name={option.descripcion.html}
      icon={option.icono.urls[0]}
      title={option.descripcion.html}
      url={option.rutadestino}
      textColor="#fff"
    />
  ));

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);

  return (
    <>
      <OptionAppMenu
        name={name}
        title="Navegación"
        mini={true}
        url="/"
        onClick={toggleShow}
      />
      <Offcanvas
        backdrop={false}
        className={`${is4K && "offcanvas-4K"}`}
        show={show}
        onHide={handleClose}
        style={{
          backgroundColor: "#001a70",
          color: "white",
          marginTop: "53px",
          width: "400px",
        }}
        {...props}
      >
        <Offcanvas.Body>
          <div>
            <FindBar showInMobile={true} handleClose={toggleShow} />
            {menuOptions.map((option, index) =>
              option.displayText === "Ahorro Y Crédito" ? (
                <LeftSecondaryMenu
                  key={index}
                  name={option?.displayText}
                  title={option?.displayText}
                  section={index + 1}
                  closeLeft={handleClose}
                  iconUrl={ROOT + option?.icono?.urls[0]}
                />
              ) : (
                <OptionNav
                  key={index}
                  name={option?.displayText}
                  icon={ROOT + option?.icono?.urls[0]}
                  title={option?.displayText}
                  url={option?.rutadestino}
                  textColor="#fff"
                />
              )
            )}
            {items}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LeftMenu;
